export let market_card = [
    {
        image: "https://cdn.britannica.com/88/62088-004-8245C6C2/graph-curve-calculus-help-steps-x-shape.jpg?w=400&h=300&c=crop",
        title: "Title",
        author: "Author",
        long_details: "This will be the long details of the function",
        short_details: "shrt details",
        usage: "this would be the usage of the specific function",
        function_address: "0x",
        creator_address:"0xA"

    },

    {
        image: "https://cdn.britannica.com/88/62088-004-8245C6C2/graph-curve-calculus-help-steps-x-shape.jpg?w=400&h=300&c=crop",
        title: "zaden",
        author: "Author",
        long_details: "This will be the long details of the function",
        short_details: "shrt details",
        usage: "this would be the usage of the specific function",
        function_address: "0x",
        creator_address:"0xA"

    },

    {
        image: "https://cdn.britannica.com/88/62088-004-8245C6C2/graph-curve-calculus-help-steps-x-shape.jpg?w=400&h=300&c=crop",
        title: "Title",
        author: "zaden",
        long_details: "This will be the long details of the function",
        short_details: "shrt details",
        usage: "this would be the usage of the specific function",
        function_address: "0x0676",
        creator_address:"0xA"
    },
]